import React from 'react';

const CURRENT_YEAR = new Date().getFullYear();

const Home = () => {
    return (
        <div className="h-screen pb-14 bg-right bg-cover" style={{ backgroundImage: "url('bg.svg')" }}>
            {/*Nav*/}
            <div className="w-full container mx-auto p-6">
                <div className="w-full flex items-center justify-between">
                    <a className="flex items-center text-gray-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl" href="/">
                        <img className="h-10 w-10 object-contain text-gray-600 pr-2" src="splash_logo.png" alt="Saat Teduh logo"></img> Saat Teduh
                    </a>
                    <div className="flex w-1/2 justify-end content-center">
                        <a
                            className="inline-block text-indigo-300 no-underline hover:text-indigo-800 hover:text-underline text-center h-10 p-2 md:h-auto md:p-4"
                            href="/support"
                        >
                        <h1 className="my-4 text-3xl md:text-5xl text-indigo-800 font-bold leading-tight text-center md:text-left">Support</h1>
                        </a>
                    </div>
                </div>
            </div>
            {/*Main*/}
            <div className="container px-6 mx-auto flex flex-wrap flex-col md:flex-row items-center">
                {/*Left Col*/}
                <div className="flex flex-col w-full xl:w-2/5 justify-center lg:items-start overflow-y-hidden">
                    <h1 className="my-4 text-3xl md:text-5xl text-indigo-800 font-bold leading-tight text-center md:text-left slide-in-bottom-h1">Saat Teduh</h1>
                    <p className="leading-normal text-base md:text-2xl mb-8 text-center md:text-left slide-in-bottom-subtitle">Ada kalanya kita perlu berteduh sejenak, lalu melangkah dengan hati lebih tenang.</p>
                    <p className="text-indigo-400 font-bold pb-8 lg:pb-6 text-center md:text-left fade-in">Download sekarang:</p>
                    <div className="flex w-full justify-center md:justify-start pb-24 lg:pb-0 fade-in">
                        <span className="pr-4 opacity-70 cursor-not-allowed">
                            <img src="App Store.svg" className="h-12 bounce-top-icons" alt="App Store (coming soon)" />
                        </span>
                        <a href='https://play.google.com/store/apps/details?id=com.dimasnath.hening'><img src="Play Store.svg" className="h-12 bounce-top-icons" alt="Play Store Logo" /></a>
                    </div>
                </div>
                {/*Right Col*/}
                <div className="w-full xl:w-3/5 py-6 overflow-y-hidden">
                    <img className="w-5/6 mx-auto lg:mr-0 slide-in-bottom rounded-2xl shadow-2xl" src="hening_preview.jpg" alt="Saat Teduh preview" />
                </div>
                {/*Footer*/}
                <div className="w-full pt-16 pb-6 text-sm text-center md:text-left fade-in">
                    <a className="text-indigo-500 no-underline hover:no-underline" href="/">&copy; Saat Teduh App {CURRENT_YEAR}</a>
                    <span className="mx-3 text-indigo-300">|</span>
                    <a className="text-indigo-500 no-underline hover:no-underline" href="/privacy-policy">Privacy Policy</a>
                    <span className="mx-3 text-indigo-300">|</span>
                    <a className="text-indigo-500 no-underline hover:no-underline" href="/terms-and-conditions">Terms & Conditions</a>
                    <span className="mx-3 text-indigo-300">|</span>
                    <a className="text-indigo-500 no-underline hover:no-underline" href="/support">Support</a>
                </div>
            </div>
        </div>
    );
}

export default Home;
